import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Conjoint } from 'model/model.conjoint';
import { AdminService } from '../../../services/admin';

@Component({
  selector: 'app-satistique-consultation-agent',
  templateUrl: './satistique-consultation-agent.component.html',
  styleUrls: ['./satistique-consultation-agent.component.scss']
})
export class SatistiqueConsultationAgentComponent implements OnInit {

  id: number;
  title:string ="";
  agents: Array<Conjoint> = new Array<Conjoint>();
  date_debut: Date;
  date_fin: Date;
  agent: Conjoint = new Conjoint(null);
  agentIm: any;
  pages: Array<number>;
  currentPage: number = 1;
  size: number = 20;
  mode_satistique_consultation: number;
  mode_satistique_consultation2: number;
  mode_satistique: number;

 //dep
 departements :any;
 directions: any;
 services : any;
 posDepartements : any;
 posDirections : any;

  constructor(public activatedRoute: ActivatedRoute, public adminService: AdminService) {
    this.id = activatedRoute.snapshot.params['id'];
    if(this.id==1 ){
      this.title = "Statistique de consultation par agent";
      this.mode_satistique= 1;
   }else if(this.id==2 ){
     this.title = "Statistique des répos par agent"
   }else if(this.id==3 ){
     this.title = "Statistique des répos par Direction"
   }else if(this.id==4 ){
    this.title = "Statistique de consultation par Direction";
    this.getDep();
    this.mode_satistique_consultation= 4;
  }

  }


  ngOnInit() {    
    this.agentIm = "";
    this.agent.infoEnregistrement.limite = this.size;
    this.agent.infoEnregistrement.pageActu = this.currentPage;
    this.getListStatistiqueAgent();
  }


  getDep(){
    this.adminService.getListeDepartement("",0,0).subscribe(data=>{
      this.departements=data;
      //this.getConjoint();
    },err=>{
  
    })
  }


  getListDirection(depId){
    this.adminService.getListeDirection(depId,0,0).subscribe(data=>{
      this.directions=data;
    //  var dep=this.getPosDepartementByNom(this.conjoint.agent_departement);
    //this.posDepartements=dep;
    },err=>{
  
    })
  }


  getListService(depId,directionId){
    this.adminService.getListeService(depId,directionId,0,0).subscribe(data=>{
      this.services=data;
      console.log("service cms" + this.services)
    },err=>{
  
    })
  }

  getListStatistiqueAgent() {
    console.log("agent im " + this.agentIm);
    if (this.agent.id)
      console.log("agent id " + this.agent.id);
    else console.log("agent id null");
    if (this.agentIm.trim.length != 0 && (!this.agent.id) || this.agent.id == null) {
      this.agentIm = "";
      console.log("agent im " + this.agentIm);
    }
    this.adminService.getStatistiqueConsultationParAgent(this.agent).subscribe(data => {
      this.agents = data;
      if (data && data.length != 0 && data[0].infoEnregistrement.totalPages) {
        this.pages = new Array(data[0].infoEnregistrement.totalPages);
        this.agent.infoEnregistrement.totalPages = data[0].infoEnregistrement.totalPages
      }
      else this.pages = new Array(0);
    }, err => {

    });
  }

  gotoPage(i: number) {
    if (i <= 0) return;
    if (i > this.pages.length) return;
    this.currentPage = i;
    this.agent.infoEnregistrement.pageActu = this.currentPage;
    //this.doSearch();
    this.getListStatistiqueAgent();
  }

  recupererInfoAgent() {
    this.adminService.getConjoinsParIm(this.agentIm)
      .subscribe(data => {
        this.agent.agent_nom = data.agent_nom;
        this.agent.agent_prenom = data.agent_prenom;
        this.agent.id = data.id;
      }, err => {
        console.log(err);
      })
  }

  onKey(event: any) {
    console.log(event.target.value);
    let key2 = event.target.value;
    let count = event.target.value.length;
    console.log(count);
    this.agent = new Conjoint(null);
    this.currentPage = 1;
    this.agent.infoEnregistrement.limite = this.size;
    this.agent.infoEnregistrement.pageActu = this.currentPage;
    if (count >= 6) {
      console.log(event.target.value.length);
      this.recupererInfoAgent();
    }
  }

  openNombreConsDirection(){
    this.mode_satistique_consultation2= 4;
  }

  openDetail(){
    this.mode_satistique= 1;
  }
}